<app-navigation-layout [hideHeader]='true'>
  <div main-container class="col-12">
    <section class="row">
      <app-product-category *ngFor="let productCategory of displayProductCategories" [productCategory]="productCategory"
        (click)="onCategorySelect(productCategory)"
        class="col-xl-12 col-xga-6"></app-product-category>
        <app-product-pack *ngFor="let productPack of productPacks" [productPack]="productPack" [countUpEnabled]="false"
          [singleProductView]="true" (counterChanged)="onCounterChanged($event)" (productPackUnlocked)="onProductPackUnlocked()"
          [ngClass]="{'col-xl-12 col-xga-6': true}">
        </app-product-pack>
    </section>
  </div>
  <span menu-container>
    <app-basket-simple-view></app-basket-simple-view>
  </span>
  <span navigation-container>
    <app-backward-forward (backwardClick)="onBack()" [hideBack]="hideBack" (forwardClick)="onForward()"
      [forwardError]="forwardError">
    </app-backward-forward>
  </span>
</app-navigation-layout>
